import { AFFILIATE_KAYAK, AFFILIATE_SKYSCANNER } from './affiliates'

export const REDIRECT_EXPERIMENT = {
  ID: 'WEB-5452',
  REDIRECT_TO_SERP: 1,
  REDIRECT_TO_DETAILS: 0,
}

// A/B test for highlighted offer multivariant
// Variant 0: Current design (show highlighted room + offer)
// Variant 1: Highlight + promote room to first position + always open
// Variant 2: Highlight + scroll to room position + always open
export const HIGHLIGHTED_OFFER_EXPERIMENT = {
  ID: 'WEB-5638',
  CURRENT_DESIGN: 0,
  PROMOTE_TO_FIRST: 1,
  SCROLL_TO_POSITION: 2,
  CURRENT_DESIGN_WITH_HIGHLIGHTED_STYLES: 3,
}

export const ROOM_CONFIGURATOR_EXPERIMENT = {
  ID: 'WEB-5693',
  CURRENT_DESIGN: 0,
  NEW_DESIGN: 1,
}

type Query = {
  aid: string | undefined
  offerType: string | undefined
}

const isKayakMultiOffer = (query: Query) =>
  query.aid === AFFILIATE_KAYAK &&
  typeof query.offerType === 'string' &&
  ['multi_offer', 'multi-offer'].includes(query.offerType)

const isSkyScannerBestOffer = (query: Query) =>
  query.aid === AFFILIATE_SKYSCANNER &&
  typeof query.offerType === 'string' &&
  ['best_offer', 'best-offer'].includes(query.offerType)

export const hasToNotifyRedirectExperiment = (query: Query) => {
  return isKayakMultiOffer(query) || isSkyScannerBestOffer(query)
}
